import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';

const PublicLayout = () => {
  return <Outlet />;
};

export default PublicLayout;
